import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ParametroAutonomia } from '../shared/parametro-autonomia.model';
import { LoaderService } from 'src/app/shared/loader/loader.service';
import { NotificationService } from 'src/app/shared/service/notification.service';
import { ParametroAutonomiaService } from '../shared/parametro-autonomia.service';

@Component({
  selector: 'app-parametro-autonomia-view',
  templateUrl: './parametro-autonomia-view.component.html',
})
export class ParametroAutonomiaViewComponent implements OnInit {
  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @Input() titlePage: string;
  @Input() data: any;

  parametroAutonomia: ParametroAutonomia;
  msgErrorGet: string;

  constructor(
    private loaderService: LoaderService,
    private notificationService: NotificationService,
    private parametroAutonomiaService: ParametroAutonomiaService,
  ) { }

  ngOnInit() {
    this.initData();
  }

  async initData() {
    this.parametroAutonomia = new ParametroAutonomia();
    this.msgErrorGet = 'Error al obtener parametro autonomia';
    this.loaderService.show();
    try {
      this.parametroAutonomia = await this.parametroAutonomiaService.obtenerParametroAutonomia(this.data.parametroAutonomia.id).toPromise();
    } catch (error) {
      this.notificationService.error(this.msgErrorGet);
      throw error;
    } finally {
      this.loaderService.hide();
    }
  }
}
